import Dayjs from 'vue-dayjs';
import Vue from 'vue';

Vue.use(Dayjs, {
    // language set, default cn
    lang: 'en',

    /**
     * addon filters { key: filter name }
     * if set {} will only dayjs base filter can use.
     */

    filters: {},

    /**
     * addon directives { key: directives name }
     * set {} to disable.
     */
    directives: {}
});
